import { ModalCustom } from "components/ModalCustom";
import { Icone, ModalBody } from "./style";
import { FaExclamation } from "react-icons/fa";

interface IProps {
  show: boolean;
  handleClose: () => void;
  onConfirm: () => void;
}

export function ModalCertezaProcessosDuplicados({
  show,
  handleClose,
  onConfirm,
}: IProps) {
  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title="Duplicação de processos"
      centered={true}
      footer={true}
      footerConfirmButton={true}
      onConfirm={onConfirm}
      confirmButtonText="Sim"
      cancelButtonText="Evitar duplicidade"
    >
      <ModalBody>
        <Icone>
          <FaExclamation />
        </Icone>
        Alguns veículos já possuem processos criados com as mesmas
        características. Deseja criar novos processos para estes veículos mesmo
        assim?
      </ModalBody>
    </ModalCustom>
  );
}
